<h2 mat-dialog-title>📱 Dispositivos Activos</h2>

<mat-dialog-content>
    <!-- LOADING -->
    <div *ngIf="loading" class="loading-wrap">
        <mat-spinner diameter="42"></mat-spinner>
        <div class="loading-title">Cargando dispositivos…</div>
        <div class="loading-sub">Esto puede tardar unos segundos.</div>
    </div>

    <!-- CONTENT -->
    <ng-container *ngIf="!loading">
        <div class="filters">
            <mat-form-field appearance="outline" class="f1">
                <mat-label>Buscar</mat-label>
                <input
                    matInput
                    [(ngModel)]="filter"
                    (input)="applyFilter()"
                    placeholder="Nombre, apellido o email"
                />
            </mat-form-field>

            <mat-form-field appearance="outline" class="f2">
                <mat-label>Plataforma</mat-label>
                <mat-select
                    [(ngModel)]="platformFilter"
                    (selectionChange)="applyFilter()"
                >
                    <mat-option value="">Todas</mat-option>
                    <mat-option value="ios">iOS</mat-option>
                    <mat-option value="android">Android</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="meta">
            Mostrando {{ filteredDevices.length }} de {{ devices.length }}
        </div>

        <div class="table-wrap" *ngIf="filteredDevices.length; else empty">
            <table mat-table [dataSource]="filteredDevices" class="full-width">
                <ng-container matColumnDef="nombre">
                    <th mat-header-cell *matHeaderCellDef>Nombre</th>
                    <td mat-cell *matCellDef="let d">
                        {{ d.nombrePersona }} {{ d.apellidoPersona }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef>Email</th>
                    <td mat-cell *matCellDef="let d">{{ d.email }}</td>
                </ng-container>

                <ng-container matColumnDef="platform">
                    <th mat-header-cell *matHeaderCellDef>Plataforma</th>
                    <td mat-cell *matCellDef="let d">
                        {{ d.pushPlatform || "—" | uppercase }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="token">
                    <th mat-header-cell *matHeaderCellDef>Token</th>
                    <td mat-cell *matCellDef="let d">
                        {{ tokenPreview(d.pushToken) }}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                ></tr>
            </table>
        </div>

        <ng-template #empty>
            <div class="empty">
                No hay dispositivos que coincidan con el filtro.
            </div>
        </ng-template>
    </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="close()">Cerrar</button>
</mat-dialog-actions>
